export let Code = {
type: `@Component({
    selector: '[pTooltip]',
    template:
        <h3 class="first">Positions</h3>
        <div class="ui-g ui-fluid">
            <div class="ui-g-12 ui-md-3">
                <input type="text" pInputText pTooltip="Enter your username" placeholder="Right">                
            </div>
            <div class="ui-g-12 ui-md-3">
                <input type="text" pInputText pTooltip="Enter your username" tooltipPosition="top" placeholder="Top">
            </div>
            <div class="ui-g-12 ui-md-3">
                <input type="text" pInputText pTooltip="Enter your username" tooltipPosition="bottom" placeholder="Bottom">
            </div>
            <div class="ui-g-12 ui-md-3">
                <input type="text" pInputText pTooltip="Enter your username" tooltipPosition="left" placeholder="Left">
            </div>
        </div>

        <h3>Focus and Blur</h3>
        <div class="ui-g ui-fluid">
            <input type="text" pInputText pTooltip="Enter your username" placeholder="Right" tooltipEvent="focus" style="margin-left:.5em">
        </div>
})
export class Tooltip {

}
`
};


// WEBPACK FOOTER //
// ./src/app/code/tooltip.ts